import React from "react";
import formats from "../../utils/formats";
import { useTranslation } from "react-i18next";

export default function TakeawayCheckoutValue(props) {
    const { restaurant, total, coupon } = props;

    const { t } = useTranslation();

    const [newtotal, setNewTotal] = React.useState();

    const hasCoupon = coupon && coupon.accepted;
    const hasTakeawayFee = restaurant.orders.takeaway.fee > 0;
    const totalWithFee = hasTakeawayFee ? total + restaurant.orders.takeaway.fee : total;

    React.useEffect(() => {
        if (coupon) {
            if (String(coupon.restaurantAccepted) === String(restaurant.id)) {
                const discountedTotal = formats.formatPercentageToPrice(coupon.discount, total);
                setNewTotal(discountedTotal);
            }
        }
    }, [coupon, restaurant.id, total]);

    return (
        <div>
            {hasCoupon ?
                <p className="flex flex-col my-6 py-4 p-4 text-center">
                    <div className="pb-2">{t("takeawayform.checkoutvalue.div_1", { total: formats.formatPrice(total) })}</div>
                    <div className="text-sm text-mycia-red">-{coupon.discount}%</div>
                    <div className="pb-2">{t("takeawayform.checkoutvalue.div_2")} <span className="font-bold">{formats.formatPrice(newtotal)}</span></div>
                    <hr className="pb-2" />
                    <span className="text-mycia-green">
                        {t("takeawayform.checkoutvalue.div_3")} <span className="font-bold">{formats.formatPrice(newtotal + restaurant.orders.takeaway.fee)}</span>
                    </span>
                    <div className="text-black">{t("takeawayform.checkoutvalue.div_4", { fee: restaurant.orders.takeaway.fee })}</div>
                </p> :
                <p className="my-6 py-4 text-center font-bold">
                    {t("takeawayform.checkoutvalue.p_1", { totalPlusFee: totalWithFee, fee: restaurant.orders.takeaway.fee })}
                </p>}
        </div>
    );
};
